module.exports = __webpack_public_path__ + "static/media/arrowDown.b4be1426.svg";